import { connect, } from 'react-redux'

import {
  selectedTripData,
  selectedEventData,
} from 'redux/reducers'

import Component from './component'

const mapStateToProps = (state) => {
  const tripData = selectedTripData(state)
  const eventData = selectedEventData(state)
  return {
    tripName: tripData ? tripData.name : '',
    eventName: eventData ? eventData.name : '',
  }
}

export default connect(mapStateToProps)(Component)



// WEBPACK FOOTER //
// ./src/components/ShareTrip/index.js